/**
 * _support_link_picker.js — pure, DOM-free logic of the staff composer's link
 * picker (support_link_picker_controller.js), tested in
 * tests/js/support_link_picker.test.mjs.
 *
 * Pages are {label, path}, as application/utils/support_links.py link_pages()
 * builds them. The picker only writes the [label](/path) text; whether it
 * becomes a link is decided by renderBody in _support_messages.js, so a picked
 * link and a typed one behave the same.
 */

/** Pages whose label or path holds every word of the search, in any case. */
export function matchPages(pages, query) {
    const words = query.toLowerCase().split(/\s+/).filter(Boolean);
    return pages.filter((page) => {
        const haystack = `${page.label} ${page.path}`.toLowerCase();
        return words.every((word) => haystack.includes(word));
    });
}

/**
 * `text` with the page's link in place of the selection from `start` to `end`
 * (selected text becomes the label), and the caret just after the link. A
 * missing position appends.
 */
export function insertLink(text, start, end, page) {
    const from = start ?? text.length;
    const to = end ?? from;
    const label = text.slice(from, to).trim() || page.label;
    const link = `[${label}](${page.path})`;
    return { text: text.slice(0, from) + link + text.slice(to), caret: from + link.length };
}
